import { logger, safeError } from '../utils/logger';
import api from '../api/api';

export class ReporteService {
  // Recibir idUsuario como parámetro
  static async getUrlReporteGestion(idUsuario: number): Promise<any> {
    try {
      // Enviarlo como query param o como parte de la URL según requiera tu backend
      // Opción A: Query Param
      const response = await api.get(`/reporte/awsqs/reporte-gestion?idUsuario=${idUsuario}`);

      return response.data;
    } catch (error: any) {
      logger.error('Error al obtener URL de QuickSight:', safeError(error));
      throw error;
    }
  }

  // URL embebida del chat Q&A Generativo (Amazon Q)
  static async getUrlQna(): Promise<any> {
    try {
      const response = await api.get(`/reporte/awsqs/qna`);

      return response.data;
    } catch (error: any) {
      logger.error('Error al obtener URL del chat Q&A de QuickSight:', safeError(error));
      throw error;
    }
  }
}